export const NAME_TOKEN = 'token'
export const SITE_ID = 'siteId'
